import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import { BillTo } from "@/containers/Manager/Report/Invoices/components/BillTo";
import { JournalSummary } from "@/containers/Manager/Report/Invoices/components/JournalSummary";
import { DebitCreditSummary } from "@/containers/Manager/Report/Invoices/components/DebitCreditSummary";

const ViewInvoiceSummary = (props) => {
  const logoSrc = process.env.REACT_APP_API_STORAGE_URL + "/logo/big_logo.png";

  return (
    <>
      <Row>
        <Col md="6" lg="6" xl="6">
          <div className="mb-4">
            <img src={logoSrc} style={{ maxWidth: "200px" }} alt="invoice-logo"/>
          </div>
          <div className="mb-2">
            <p>
              3801 PGA Blvd <br /> Suite 600 <br /> Palm Beach Gardens, FL 33410
            </p>
          </div>
          <div>
            <p>
              Bill To : <br />
              <BillTo invoice={props.invoice} key={"billto-item"} />
            </p>
          </div>
        </Col>
        <Col md="6" lg="6" xl="6">
          <div className="text-right float-right">
            <span className="outline">Invoice # {props.invoice.invoice_number}</span>
            <div className="d-flex justify-content-between">
              <div>Date: </div>
              <div>{props.invoice.date_end}</div>
            </div>
            <div className="d-flex justify-content-between">
              <div className= {props.invoice.date_due === props.invoice.date_end
                  ? "d-none"
                  : ""} >Due Date: </div>
              <div>
                {props.invoice.date_due === props.invoice.date_end
                  ? "Due upon receipt"
                  : props.invoice.date_due}
              </div>
            </div>
            {props.invoice.invoice_po_number && (
              <div className="d-flex justify-content-between">
                <div>PO Number: </div>
                <div>{props.invoice.invoice_po_number}</div>
              </div>
            )}
            {props.invoice.dues?.label && (<div className="d-flex justify-content-between">
              <div>{props.invoice.dues?.label}: </div>
              <div>{props.invoice.dues?.amount}</div>
            </div>)}
          </div>
          <div style={{ clear: "both", fontSize: "11px" }}>
            <br />
            <table className="float-right">
              <tbody>
                <tr>
                  <td></td>
                  <td>
                    <u>Wire Transfer</u>
                  </td>
                  <td>
                    <u>ACH Payment</u>
                  </td>
                </tr>
                <tr>
                  <td>Routing Number (RTN/ABA):</td>
                  <td>021000021</td>
                  <td>102001017</td>
                </tr>
                <tr>
                  <td>Account Number:</td>
                  <td>138091170</td>
                  <td>138091170</td>
                </tr>
                <tr>
                  <td>Bank:</td>
                  <td>Chase Bank, NA</td>
                  <td>Chase Bank, NA</td>
                </tr>
                <tr>
                  <td valign="top">Address:</td>
                  <td>
                    2696 S Colorado Blvd&nbsp;&nbsp;&nbsp;
                    <br /> Denver, CO 80222
                  </td>
                  <td>
                    2696 S Colorado Blvd
                    <br /> Denver, CO 80222
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
      <JournalSummary invoice={props.invoice} />
      <br />
      <h4 className="text-center" style={{ border: "1px solid #ccc" }}>
        Invoice Details
      </h4>
      <Row>
        <Col className="table-responsive">
          <table className="table table-hover">
            <tbody>
              <tr>
                <th>Program</th>
                <th>Description</th>
                <th align="right">Total</th>
              </tr>
              <DebitCreditSummary invoice={props.invoice} />
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    program: state.program,
    organization: state.organization,
  };
};

export default connect(mapStateToProps)(ViewInvoiceSummary);
